<div class="loader" [ngClass]="{ active: is_loading}">
  <img src="../../../assets/branding/loader.gif"/>
</div>
<div #viewer id="preview"></div>
